import React ,{Component} from 'react';
import DoughnutChart from './DoughnutChart';
import "./Home.css";
import Footer from "./Footer";
import profileImg from "./images/chainingImage.jpg";
class mentorAnlysis extends Component{

  constructor(props){
    super(props);
    this.state = {
                  userName: ''
                }
  }

  componentDidMount(){
    let auth = JSON.parse(localStorage.getItem('user'));
    this.setState({userName : auth.userName})
  }
  render(){
        return ( 
          <div className="homeContainer repo_body">
            <div className='profileDivision' style={{position:'absolute', width:'100px', height:'100px', right:'20px'}}>
              <img src={profileImg} alt='Profile' style={{width:'100%', height:'100%', borderRadius:'50%'}}/>
            </div>
            <div className='information' style={{position:'absolute', right:'130px', top:'25px'}}>
              <h5>{this.state.userName}</h5>
            </div>
            <div className='logOut' style={{position:'absolute', right:'20px', top:'120px',zIndex:9}}>
              <a href='/logout'>
                <button className='btn btn-dark'>Logout</button>
              </a>
            </div>
            <DoughnutChart/>
            <Footer />
          </div>
        );
      };
}
export default mentorAnlysis;
